<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @rejected="rejected"
      @passed="passed"
      @openEditPage="openEditPage"
      @choose-change="(e) => (checkedRows = e)"
    >
      <template slot="header">
        <div class="table_toolbar">
          <page-header ref="header" @query="getData" @reset="resetPage">
            <!-- <b-button
              :disabled="!checkedRowCount"
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="confirm('passed')"
              v-if="allow('R')"
            >
              {{ $l('menu_text_passed') || '审核通过' }}
            </b-button>

            <b-button
              :disabled="!checkedRowCount"
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="confirm('rejected')"
              v-if="allow('R')"
            >
              {{ $l('menu_text_rejected') || '审核驳回' }}
            </b-button> -->
          </page-header>
        </div>
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return {
      usePage: true,
      table: [],
      checkedRows: [],
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFlipOrderListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.checkedRows = []
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    confirm(type) {
      const amzFlipOrderCodes = this.checkedRows.map((e) => e.amzFlipOrderCode)
      if (type == 'rejected') {
        this.rejected({ amzFlipOrderCodes })
      } else {
        this.passed({ amzFlipOrderCodes })
      }
    },
    rejected({ amzFlipOrderCodes }) {
      this.$prompt(this.$l('tips_review') || '是否要审核驳回？', '提示', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        inputPlaceholder: '请输入驳回原因',
        inputType: 'textarea',
        inputValidator: (value) => {
          if (value) {
            return true
          }
          return '请输入驳回原因'
        },
        inputErrorMessage: '请输入驳回原因',
      })
        .then(({ value }) => {
          if (this.loadingOpen()) return
          this.$api
            .ecomAmzFlipOrderReviewRejectionApi({
              amzFlipOrderCodes,
              rejectReason: value,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  showClose: true,
                  message: this.$l('tips_review_success') || '驳回成功',
                  type: 'success',
                })
              }
              this.$refs.header.query()
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
        })
    },
    passed({ amzFlipOrderCodes }) {
      this.$confirm(
        this.$l('tips_passed') || '是否要审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .ecomAmzFlipOrderApprovedApi({
            amzFlipOrderCodes,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status == 200) {
              this.$message({
                showClose: true,
                message: this.$l('tips_passed_success') || '通过成功',
                type: 'success',
              })
            }
            this.$refs.header.query()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    openEditPage({ pageType, data = {} }) {
      const { amzFlipOrderCode = '', amzFlipOrderNo = '' } = data
      let params = { pageType }
      let query = {}
      if (amzFlipOrderCode) params = { ...params, code: amzFlipOrderCode }
      if (amzFlipOrderNo) query = { ...query, amzFlipOrderNo: amzFlipOrderNo }
      this.$router.push({
        name: 'ecom-awsBiz-skuFlipReview-detail',
        params,
        query,
      })
    },
    close() {
      this.addPlanOptions.visible = false
      this.reload()
    },
  },
}
</script>
